var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('DesktopTopPart'),_c('v-row',[_c('v-col',{staticClass:"white px-0"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"grow"},[_c('PaymentForm')],1)],1)],1)],1)],1),_c('v-row',[_c('PageFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }